// =====================================================================
// 我的社保 · 缴费模拟数据（存档）：养老 / 工伤 / 失业（201609 - 202608 共120个月）
// 数据依据：《江苏省企业职工基本养老保险权益记录单》
//           缴费区间 2016年9月 - 2026年8月，合计 120 个月
// 说明：权益记录单「个人缴费」列为养老/医疗/失业三险个人部分之和（10.5%），
//       养老页展示：个人 8%、单位 16%、合计 24%（按缴费基数计）。
//       2026 年实测扣缴（基数4952）：养老396.16、医疗99.04、失业24.76，合计519.96，
//       与记录单末期 9879.24 / 19个月 = 519.96 完全吻合。
//       工伤保险：个人不缴、单位 0.2%（基数4952 → 9.90/月）；
//       失业保险：个人 0.5%、单位 0.5%（基数4952 → 24.76/24.76/49.52）。
//
// 权益记录单年度汇总（个人缴费为三险合计口径）：
//   2016.09-2017.06  10月 基数2628 个人2759.40  中锗科技有限公司        南京市溧水区
//   2017.07-2018.06  12月 基数2940 个人3704.40  中锗科技有限公司        南京市溧水区
//   2018.07-2019.06  12月 基数3125 个人3937.56  中锗科技有限公司        南京市溧水区
//   2019.07-2020.06  12月 基数3368 个人4243.68  中锗科技有限公司        南京市溧水区
//   2020.07-2021.06  12月 基数3368 个人4243.68  江苏超芯星半导体有限公司 南京市江北新区
//   2021.07-2021.12   6月 基数3800 个人2394.00  江苏超芯星半导体有限公司 南京市江北新区
//   2022.01-2022.12  12月 基数4250 个人5355.00  江苏超芯星半导体有限公司 南京市江北新区
//   2023.01-2023.12  12月 基数4494 个人5662.44  江苏超芯星半导体有限公司 南京市江北新区
//   2024.01-2024.12  12月 基数4879 个人6147.60  江苏超芯星半导体有限公司 南京市江北新区
//   2025.01-2026.08  20月 基数4952 个人9879.24  江苏超芯星半导体有限公司 南京市江北新区
// =====================================================================

// 缴费基数分段（同一时段内基数/参保单位不变）
const SEGMENTS = [
  { start: '201609', end: '201706', base: 2628, org: '中锗科技有限公司' },
  { start: '201707', end: '201806', base: 2940, org: '中锗科技有限公司' },
  { start: '201807', end: '201906', base: 3125, org: '中锗科技有限公司' },
  { start: '201907', end: '202006', base: 3368, org: '中锗科技有限公司' },
  { start: '202007', end: '202106', base: 3368, org: '江苏超芯星半导体有限公司' },
  { start: '202107', end: '202112', base: 3800, org: '江苏超芯星半导体有限公司' },
  { start: '202201', end: '202212', base: 4250, org: '江苏超芯星半导体有限公司' },
  { start: '202301', end: '202312', base: 4494, org: '江苏超芯星半导体有限公司' },
  { start: '202401', end: '202412', base: 4879, org: '江苏超芯星半导体有限公司' },
  { start: '202501', end: '202608', base: 4952, org: '江苏超芯星半导体有限公司' }
]

// 字符串 YYYYMM 自增 1 个月
function nextMonth(ym) {
  let y = parseInt(ym.slice(0, 4), 10)
  let m = parseInt(ym.slice(4, 6), 10)
  m += 1
  if (m > 12) { m = 1; y += 1 }
  return '' + y + (m < 10 ? '0' + m : '' + m)
}

function round2(n) {
  return Math.round(n * 100) / 100
}

// 按月展开（时间正序：201609 -> 202608）
const monthlyAsc = []
const injuryAsc = []
const unemployAsc = []
SEGMENTS.forEach(seg => {
  for (let ym = seg.start; ; ym = nextMonth(ym)) {
    const base = seg.base
    monthlyAsc.push({
      month: ym,
      personal: round2(base * 0.08), // 养老个人 8%
      company: round2(base * 0.16),  // 养老单位 16%
      total: round2(base * 0.24),    // 合计 24%
      base: String(base),
      flag: '已实缴',
      org: seg.org
    })
    // 工伤：个人不缴，单位 0.2%
    const injCompany = round2(base * 0.002)
    injuryAsc.push({
      month: ym,
      personal: 0,
      company: injCompany,
      total: injCompany,
      base: String(base),
      flag: '已实缴',
      org: seg.org
    })
    // 失业：个人 0.5%、单位 0.5%、合计 1%
    const uePersonal = round2(base * 0.005)
    const ueCompany = round2(base * 0.005)
    unemployAsc.push({
      month: ym,
      personal: uePersonal,
      company: ueCompany,
      total: round2(base * 0.01),
      base: String(base),
      flag: '已实缴',
      org: seg.org
    })
    if (ym === seg.end) break
  }
})

// 页面按最新月份在前展示
const pensionPayments = monthlyAsc.slice().reverse()
const injuryPayments = injuryAsc.slice().reverse()
const unemployPayments = unemployAsc.slice().reverse()

export { pensionPayments, injuryPayments, unemployPayments, SEGMENTS, monthlyAsc }
export default pensionPayments



// WEBPACK FOOTER //
// ./src/data/mySocialMock.js